<template>
  <table-list
      ref="list"
      :request-params="{userNum: $route.query.num}"
      @query="handleLoadList"
      v-bind="$attrs"
      :data="tableData">
    <el-table-column align="center" prop="hardScore" :label="$t('硬度')"  />
    <el-table-column align="center" prop="rwr" :label="$t('米比水')" />
    <el-table-column align="center" prop="riceWeight" :label="$t('米')" />
    <el-table-column align="center" prop="waterWeight" :label="$t('水')" />
    <el-table-column align="center" prop="createTime" :label="$t('日期')">
      <template v-slot="{row}">
        {{row.createTime | formatDate}}
      </template>
    </el-table-column>
  </table-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
export default {
  name: "CookRecord",
  components: {TableList},
  props: {
    tabCurrent: {
      type: String,
      default: ""
    },
    current: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableData: []
    }
  },
  methods:  {
    async handleLoadList(params, setTotal) {
      try {
        let res = await request(this.$api.boiledRiceRecord.list, params);
        for (const key in res) {
          if(Array.isArray(res[key])) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager.itemCount);
      }catch(e) {
        console.log(e);
      }
    }
  },
  watch: {
    current: {
      handler(val) {
        if(val === this.tabCurrent) {
          this.$nextTick(() => {
            this.$refs.list.handleRequest();
          })
        }
      },
      immediate: true,
    }
  }
}
</script>

<style scoped>

</style>
